export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9609.8e8f284c.jpg";